import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface MenuPlanParamsState {
  params: any; // Define a more specific type if possible
}

const initialState: MenuPlanParamsState = {
  params: null,
};

const initiateMenuProjectionSliceParams = createSlice({
  name: 'initiateMenuProjectionParams',
  initialState,
  reducers: {
    setMenuProjectionParams(state, action: PayloadAction<any>) {
      state.params = action.payload;
    },
  },
});

export const { setMenuProjectionParams } = initiateMenuProjectionSliceParams.actions;

export default initiateMenuProjectionSliceParams.reducer;
